import React from 'react';

import { RenderComponent } from '@bcp-channels-sharedcomponents-reactjs/core';
import { TooltipInnerProps } from '@components';

import { SimulationValuesDescriptionAb } from './simulationValuesDescription.ab';
import { SimulationValuesDescriptionBcp } from './simulationValuesDescription.bcp';

export interface SimulationValuesDescriptionProps {
	value: number | string;
	label: string;
	promoValue?: number | null | undefined;
	currency?: string;
	labelNote?: string;
	decimalScale?: number;
	tooltip?: TooltipInnerProps;
}

export const SimulationValuesDescription: React.FC<SimulationValuesDescriptionProps> = (
	props: SimulationValuesDescriptionProps
): JSX.Element => {
	return (
		<RenderComponent
			components={{
				ab: {
					desktop: <SimulationValuesDescriptionAb {...props} />,
					mobile: <SimulationValuesDescriptionAb {...props} />,
					intranet: null,
				},
				bcp: {
					desktop: <SimulationValuesDescriptionBcp {...props} />,
					mobile: <SimulationValuesDescriptionBcp {...props} />,
					intranet: null,
				},
			}}
		/>
	);
};
